"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Rating = function Rating(_ref) {
  var steps = _ref.steps,
      initialRating = _ref.initialRating,
      placeholderRating = _ref.placeholderRating,
      readonly = _ref.readonly,
      emptySymbol = _ref.emptySymbol,
      fullSymbol = _ref.fullSymbol,
      onChangeProp = _ref.onChange,
      onHover = _ref.onHover,
      size = _ref.size,
      classNameProp = _ref.className;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      highlight = _useState2[0],
      setHighlight = _useState2[1];

  var _useState3 = (0, _react.useState)(initialRating ? initialRating : placeholderRating),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var handleHover = function handleHover(event, index) {
    if (!readonly) {
      setHighlight(index);
    }

    onHover(event, index);
  };

  var onChange = function onChange(event, index) {
    if (!readonly) {
      setSelected(index);
    }

    onChangeProp(event, index);
    return index;
  };

  var className = (0, _clsx["default"])('od-rating', {
    'small': size === 'small',
    'medium': size === 'medium',
    'large': size === 'large'
  }, classNameProp);
  return _react["default"].createElement("div", {
    className: className
  }, Array.from(Array(steps).keys()).map(function (v, index) {
    return _react["default"].createElement("img", {
      key: "rating-".concat(index + 1),
      src: highlight >= 0 ? highlight >= index ? fullSymbol : emptySymbol : selected >= index ? fullSymbol : emptySymbol,
      onMouseEnter: function onMouseEnter(e) {
        return handleHover(e, index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHighlight(-1);
      },
      onMouseDown: function onMouseDown(e) {
        return onChange(e, index);
      }
    });
  }));
};

Rating.propTypes = {
  steps: _propTypes["default"].number.isRequired,
  initialRating: _propTypes["default"].number,
  placeholderRating: _propTypes["default"].number,
  readonly: _propTypes["default"].bool,
  emptySymbol: _propTypes["default"].string.isRequired,
  fullSymbol: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  onHover: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large'])
};
Rating.defaultProps = {
  steps: 5,
  initialRating: -1,
  placeholderRating: -1,
  readonly: false,
  emptySymbol: '',
  fullSymbol: '',
  onChange: function onChange() {},
  onHover: function onHover() {},
  size: 'medium'
};
var _default = Rating;
exports["default"] = _default;